import { PdInputArea } from "./pd-input-area/PdInputArea.js";
//#region src/pd-input-area/pd-input-area.ts
var tag = "pd-input-area";
if (!customElements.get(tag)) customElements.define(tag, PdInputArea);
//#endregion
export { PdInputArea };
